import { useMobile } from 'frontend/src/hooks/useMobile';
import { pathname } from 'frontend/src/utils';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import Bank from '../../SubmitApplication/Bank';
import ConnectAccountCompleted from './ConnectAccountCompleted';
import ConnectPlatformAccount from './ConnectPlatformAccount';
import PrivacyAndTermsContainer from './PrivacyAndTermsContainer';

export default function Stepper({
  hasBank,
  plaidLinkToken,
  business,
  amzAccounts,
  setHasBank,
  expandBank,
}) {
  const history = useHistory();
  let initialStep = 1;
  if (expandBank) {
    initialStep = hasBank ? 3 : 2;
  }
  const [step, setStep] = useState(initialStep);
  const mobile = useMobile('sm');

  function goForward() {
    if (step === 3) {
      history.push(pathname.plans.url);
    } else if (step === 1 && hasBank) {
      setStep(3);
    } else {
      setStep(step + 1);
    }
  }

  return (
    <>
      {step === 1 && (
        <ConnectPlatformAccount
          amzAccounts={amzAccounts}
          goForward={goForward}
          business={business}
        />
      )}
      {step === 2 && (
        <Bank
          goForward={goForward}
          plaidLinkToken={plaidLinkToken}
          hasBank={hasBank}
          setHasBank={setHasBank}
          mobile={mobile}
        />
      )}
      {step === 3 && <ConnectAccountCompleted goForward={goForward} />}
      <PrivacyAndTermsContainer />
    </>
  );
}
